import React, { Component } from 'react';
import './App.css';
import NowPlaying from './NowPlaying';
import RecentlyPlayed from './RecentlyPlayed';
import IcecastNowPlaying from './IcecastNowPlaying';

const default_album_art = 'https://albumart.customchannels.rocks/default-album-art.png';

class App extends Component {

  constructor(){
    super();

    this.state = {
      nowplaying: {
        title: "Title",
        artist: 'Artist',
        album: "Album",
        album_art: { large: default_album_art }},
      tracks: []
    };
  }

  setTrackData(data){
    let tracks = data.data.slice();
    let nowplaying = tracks[0];
    tracks.shift();

    this.setState({

      nowplaying: nowplaying,
      tracks: tracks
    });
  }

  componentDidMount(){
      // get the now playing
      const nowplaying = new IcecastNowPlaying(2133, 'http://stream.customchannels.net/holiday_ksyz_96.mp3');

      nowplaying.checkIcecast((data) => {
        this.setTrackData(data);
      });

      setInterval(() => {
        nowplaying.checkIcecast((data) => {
          this.setTrackData(data);
        })
      }, 30000);
  }

  render() {
    return (
      <div className="App container">
        <header className="row Header">
          <div className="Logo"></div>
        </header>

        <div className="clearfix"></div>

        { /* <a rel="noopener noreferrer" href="http://apfelfuneralhome.com/" target="_blank"><div className="Banner"></div></a> */ }

        <div className="Player">
          <NowPlaying track={ this.state.nowplaying } />
          <div className="clearfix"></div>
          <RecentlyPlayed tracks={ this.state.tracks } />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js